module.exports = __webpack_public_path__ + "img/icon-image.3b628547.png";